import React, { useRef, useState } from "react";
import { useLoaderData, useNavigate, Form } from "react-router-dom";
import { addEntity, updateEntity, deleteEntity } from "../../API";
import InputFormField from "../../components/InputFormField";
import SelectFormField from "../../components/SelectFormField";
import UpdateDeleteBar from "../../components/UpdateDeleteBar";

const ALL_MANUFACTURERS = { id: null, name: "All Manufacturers" };

function PhotoHashtag() {
  const { entity: initialEntity, manufacturers } = useLoaderData();
  const navigate = useNavigate();
  const refForm = useRef();

  const [manufacturer, setManufacturer] = useState(
    initialEntity.manufacturer ?? ALL_MANUFACTURERS
  );

  const allManufacturers = [ALL_MANUFACTURERS, ...manufacturers];

  const submit = () =>
    refForm.current?.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));

  const itemSave = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const hashtag = formData.get("hashtag");
    const payload = {
      hashtag,
      manufacturer: manufacturer?.id ? { id: manufacturer.id } : null,
    };
    if (initialEntity.id) {
      await updateEntity("photoHashtags", { ...payload, id: initialEntity.id });
    } else {
      await addEntity("photoHashtags", payload);
    }
    navigate("../photo-hashtags");
  };

  const itemDelete = async () => {
    await deleteEntity("photoHashtags", initialEntity);
    navigate("../photo-hashtags");
  };

  const isEdit = !!initialEntity.id;

  return (
    <div className="flex-grow-1 overflow-auto">
      <UpdateDeleteBar
        onDelete={isEdit ? itemDelete : undefined}
        onSave={submit}
        title={initialEntity.hashtag || "New Photo Hashtag"}
      />
      <div className="container-fluid py-4 px-4">
        <Form onSubmit={itemSave} ref={refForm}>
          <div className="card shadow-sm mb-4">
            <div className="card-body p-4">
              <div className="row g-3">
                <div className="col-md-6">
                  <InputFormField
                    label="Hashtag"
                    name="hashtag"
                    value={initialEntity.hashtag}
                  />
                </div>
                <div className="col-md-6">
                  <SelectFormField
                    label="Manufacturer"
                    value={manufacturer}
                    options={allManufacturers}
                    onChange={setManufacturer}
                    objectValue={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
}

export default PhotoHashtag;
